export const destination: types.appConfig.destination = 'PROD';
export const env: types.appConfig.env = 'PROD';
export const lockScreenTimeout = 900000;
export const featuresActive: types.appConfig.featuresActive = {
	sidebar: {
		orderTracking: false,
		billingPaymentTrack: true,
		bulkPurchase: false,
		prepaidLoyalty: false,
		fiberPro: true,
		aamaliPlus: true,
		btlOffer: true,
		bandWidthOnDemand: true,
		copperPlan: true,
		fiberPro2b: true,
		bankMuscat: false,
		wfbb: true,
		voc: false,
		newDashboardEnable: false,
		isLogin2FAEnabledEbu: true,
		isPwdEncryptionEnabledEbu: true,
		allowDataReportingHeader: false,
		isMobilePostpaidServiceOn: false,
	},
};
export const featuresLimitations: types.appConfig.featuresLimitations = {
	bulkPurchase: false,
};

export const eshopURL: types.appConfig.eshopURL = 'https://store.omantel.om/cart?noHeaderFooter=true';
export const eshopSuccessURL: types.appConfig.eshopSuccessURL = 'https://store.omantel.om/payment/success';
export const eshopFailureURL: types.appConfig.eshopFailureURL = 'https://store.omantel.om/payment/failure';

export const UserGuideURL =
	'https://omantel.om/wcm/connect/fb0eaed8-2d5c-4180-be6a-1d9b3befafb8/user_guide.pdf?MOD=AJPERES';
export const BankMuscatIntroEn =
	'connect/b02838f8-83ae-4b1c-b26e-090eecc9504f/BankMuscat_Subscribe_Process.pdf?MOD=AJPERES&id=1726558955422';
export const BankMuscatIntroAr =
	'connect/618b92b7-44d5-4b06-a3f8-4dfc1f90df8a/BankMuscat_Subscribe_Process.pdf?MOD=AJPERES&id=1726558984956';
